import { createAction, props } from '@ngrx/store';
import { Role } from './interfaces/role.interface';

export const ROLES_FEATURE_NAME = 'roles';

export const setRoles = createAction(
  `[${ROLES_FEATURE_NAME}] Set roles`,
  props<{ roles: Role[] }>(),
);

export const getRoles = createAction(
  `[${ROLES_FEATURE_NAME}] Get roles`,
);

export const getRolesSuccess = createAction(
  `[${ROLES_FEATURE_NAME}] Get roles success`,
  props<{ roles: Role[] }>(),
);

export const getRolesFailed = createAction(
  `[${ROLES_FEATURE_NAME}] Get roles failed`,
);

export const getRole = createAction(
  `[${ROLES_FEATURE_NAME}] Get role`,
  props<{ roleId: string }>(),
);

export const getRoleSuccess = createAction(
  `[${ROLES_FEATURE_NAME}] Get role success`,
  props<{ role: Role }>(),
);

export const getRoleFailed = createAction(
  `[${ROLES_FEATURE_NAME}] Get role failed`,
);

export const addRole = createAction(
  `[${ROLES_FEATURE_NAME}] Add role`,
  props<{ roleName: string, scopes: string[] }>(),
);

export const addRoleSuccess = createAction(
  `[${ROLES_FEATURE_NAME}] Add role success`,
  props<{ role: Role }>(),
);

export const addRoleFailed = createAction(
  `[${ROLES_FEATURE_NAME}] Add role failed`,
);

export const updateRole = createAction(
  `[${ROLES_FEATURE_NAME}] Update role`,
  props<{ roleId: string, scopes: string[] }>(),
);

export const updateRoleSuccess = createAction(
  `[${ROLES_FEATURE_NAME}] Update role success`,
  props<{ role: Role }>(),
);

export const updateRoleFailed = createAction(
  `[${ROLES_FEATURE_NAME}] Update role failed`,
);

export const removeRole = createAction(
  `[${ROLES_FEATURE_NAME}] Remove role`,
  props<{ roleId: string }>(),
);

export const removeRoleSuccess = createAction(
  `[${ROLES_FEATURE_NAME}] Remove role success`,
  props<{ roleId: string }>(),
);

export const removeRoleFailed = createAction(
  `[${ROLES_FEATURE_NAME}] Remove role failed`,
);

export const setRolesFilter = createAction(
  `[${ROLES_FEATURE_NAME}] Set roles filter`,
  props<{ filter: string }>(),
);
